import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import {
  deleteIQTestQuestion,
  getAllIQTest,
  getOneIQTest,
} from "../../helper/apicalls/iqTest";
import Cookies from "js-cookie";
import GlobalLoader from "../common/GlobalLoader";
import IqTestCard from "./iqTestCard";
import "../../styles/admin/iqTest.scss";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import IqTestCreate from "./iqTestCreate";
import IqTestQuestionPreview from "./iqTestQuestionPreview";
import DeleteConfirmPopUp from "../common/deleteConfirmPopUp";

const IqTest = () => {
  const auth_token = Cookies.get("admin_token");
  const { setHeaderName, setIsShowSearch } = useOutletContext();
  const [loader, setloader] = useState(false);
  const [iqTestList, setIqTestList] = useState([]);
  const [isOpenIQTestCreate, setIsOpenIQTestCreate] = useState(false);
  const [isReferesh, setIsReferesh] = useState(false);
  const [isShowIQTestPreview, setIsShowIQTestPreview] = useState(false);
  const [showPreviewQuestion, setShowPreviewQuestion] = useState([]);
  const [editableListQuestion, setEditableListQuestion] = useState();
  const [isEditAction, setIsEditAction] = useState(false);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [selectedIQTest, setSelectedIQTest] = useState(null);

  const aiCategories = [
    { label: "Cognitive function", value: "cognitive_function" },
    { label: "Social emotional skill", value: "social_emotional_skill" },
    {
      label: "Physical development skill",
      value: "physical_development_skill",
    },
    { label: "Creative imagination", value: "creative_imagination" },
    {
      label: "Critical thinking curiosity",
      value: "critical_thinking_curiosity",
    },
    { label: "Language communication", value: "language_communication" },
    { label: "Self regulation behavior", value: "self_regulation_behavior" },
  ];

  const getCategoriesValue = (key) => {
    const aiCategoriesValue = aiCategories?.filter((i) => i?.value === key);
    return aiCategoriesValue[0];
  };

  const fetchIqTestData = async () => {
    setloader(true);
    try {
      const res = await getAllIQTest(auth_token, "iq");
      setIqTestList(res || []);
    } catch (err) {
      console.error(err);
    } finally {
      setloader(false);
    }
  };

  const handleEdit = async (p) => {
    setIsEditAction(true);
    try {
      const res = await getOneIQTest(auth_token, p?.id);
      setEditableListQuestion(res);
    } catch (err) {
      console.error(err);
    }
    setIsOpenIQTestCreate(true);
  };

  const handleDelete = (d) => {
    setSelectedIQTest(d);
    setIsConfirmDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteIQTestQuestion(auth_token, selectedIQTest?.id);
      setIsConfirmDeleteOpen(false);
      await fetchIqTestData();
    } catch (err) {
      console.error(err);
    }
  };

  const handleViewable = async (d) => {
    try {
      const res = await getOneIQTest(auth_token, d?.id);
      const p = res?.content?.map((d) => {
        const update = {
          ...d,
          categories: getCategoriesValue(d?.categories),
        };
        return update;
      });

      setShowPreviewQuestion(p || []);
    } catch (err) {
      console.error(err);
    }
    setIsShowIQTestPreview(true);
  };

  useEffect(() => {
    fetchIqTestData();
    setIsShowSearch(true);
    setHeaderName("IQ Test");
  }, [isReferesh]);

  return (
    <div className="iq-test-container">
      {loader && <GlobalLoader visible={loader} />}
      <div className="iq-test-grid">
        <div
          className="iq-test iq-test-add-card"
          onClick={() => {
            setIsOpenIQTestCreate(true);
          }}
        >
          <div className="iq-test-card-body">
            <AddCircleOutlineOutlinedIcon className="iq-test-add-icon" />
            <h3 className="iq-test-title">Add </h3>
          </div>
        </div>
        {iqTestList?.map((data, i) => {
          return (
            <IqTestCard
              key={i}
              data={data}
              onEdit={handleEdit}
              handleClick={() => {
                handleViewable(data);
              }}
              onDelete={handleDelete}
            />
          );
        })}
      </div>
      {isOpenIQTestCreate && (
        <IqTestCreate
          isOpen={isOpenIQTestCreate}
          onClose={() => {
            setIsOpenIQTestCreate(false);
            setShowPreviewQuestion([]);
            setEditableListQuestion([]);
            setIsEditAction(false);
          }}
          setIsReferesh={setIsReferesh}
          isReferesh={isReferesh}
          setIsShowIQTestPreview={setIsShowIQTestPreview}
          showPreviewQuestion={showPreviewQuestion}
          setShowPreviewQuestion={setShowPreviewQuestion}
          editableListQuestion={editableListQuestion}
          isEditAction={isEditAction}
          setIsEditAction={setIsEditAction}
        />
      )}
      {isShowIQTestPreview && (
        <IqTestQuestionPreview
          isOpen={isShowIQTestPreview}
          onClose={() => {
            setIsShowIQTestPreview(false);
          }}
          showPreviewQuestion={showPreviewQuestion}
        />
      )}
      { isConfirmDeleteOpen &&<DeleteConfirmPopUp
          isConfirmDeleteOpen={isConfirmDeleteOpen}
          setIsConfirmDeleteOpen={setIsConfirmDeleteOpen}
          handleDelete={handleConfirmDelete}
        />}
    </div>
  );
};

export default IqTest;
